import styled from 'styled-components';

type Props = {};

export default styled.section<Props>`
  .box-top {
    margin-bottom: 8px;
  }
  .icon-datepicker {
    position: absolute;
    pointer-events: none;
    right: 8px;
  }
  .box-select {
    display: flex;
    flex-wrap: wrap;
    .input-onsite {
      margin-bottom: 0;
      width: 100%;
    }
    .input-checkbox {
      margin-bottom: 0;
    }
    .ant-row {
      .ant-form-item-label {
        padding-top: 5px;
      }
      .ant-form-item-control {
        .ant-form-item-explain-error {
          width: 177px;
        }
      }
    }
  }
  .button-add {
    img {
      color: white;
      border: 1px solid black;
      border-radius: 99px;
      margin-left: 10px;
      margin-top: 5px;
      cursor: pointer;
      width: 20px;
      height: 20px;
    }
  }
  .pick_from_to_date {
    .ant-form-item-label {
      display: flex;
    }
  }
  .titleSiteName {
    margin-left: 8px;
    color: #000000;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
  }
  .group-input {
    padding: 0 24px 16px 24px;
    .ant-form-item {
      flex-direction: row;
      display: flex;
      &.note-field {
        margin-bottom: 0;
      }
      .ant-form-item-label {
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 0;
        .ant-form-item-no-colon {
          color: #000000;
          min-width: 48px;
          margin-right: 8px;
          font-size: 16px;
          letter-spacing: 0;
          line-height: 24px;
        }
      }
    }
    .select-field {
      min-width: 400px;
    }
  }
  .ant-modal-footer {
    .ant-btn-primary {
      margin-left: 16px !important;
    }
  }
  .box_date {
    max-height: 250px;
    overflow-y: auto;
  }
  .select-date {
    width: 177px;
  }
  .center-text {
    height: 32px;
    padding: 6px 20px 0 20px;
  }

  .rmdp-input {
    height: 32px;
    padding-right: 32px;
    width: 100%;
  }
  .rmdp-container {
    width: 100%;
  }
  .rmdp-week-day {
    color: #aba8a8;
    font-family: serif;
    font-size: 12px;
  }
  .sd {
    font-size: 12px;
  }
  .rmdp-day {
    height: 35px;
    width: 35px;
  }
  .rmdp-arrow-container {
    border-radius: 10px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    margin: 0 15px;
    width: 0;
  }
  .rmdp-arrow-container:hover .rmdp-arrow {
    border-width: 0 2px 2px 0;
    border: solid #5a5a5a;
    border-width: 0 2px 2px 0;
    display: inline-block;
    height: 3px;
    margin-top: 5px;
    padding: 3px;
    width: 3px;
  }
  .rmdp-arrow {
    border-width: 0 2px 2px 0;
    border: solid #5a5a5a;
    border-width: 0 2px 2px 0;
    display: inline-block;
    height: 3px;
    margin-top: 5px;
    padding: 3px;
    width: 3px;
  }
`;

export const HeaderStyle = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  img {
    margin-right: 8px;
  }
`;
